/*
 * ******************************************************************
 * Copyright (c) 2026 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

// Stand-in for 'lunr-languages/lunr.multi' (not installed - see empty-module.js).
// Unlike the per-language stemmers, this one is expected to attach a `multiLanguage()`
// factory onto the target (elasticlunrjs), whose result is later invoked as a pipeline
// plugin via `index.use(...)`. Both need to exist and be callable to avoid a crash;
// real multi-language tokenization is intentionally not implemented.
export default function(target) {
    if (target && typeof target.multiLanguage !== "function") {
        target.multiLanguage = function() {
            return function() {};
        };
    }
}
